import { abbreviate } from "../utils/utils";
import { selectChat } from '../../redux/chatSlice';
import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
function Chat(props) {

    const [lastMessage, setLastMessage] = useState(null);

    useEffect(() => {
        if (props.chat.messages) {
            setLastMessage(props.chat.messages.slice(-1).pop().text)
        }

        return () => {
            // component unmounts
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={"d-flex align-items-center me-2 " + (props.chat.selected === true ? "bg-light-primary" : "")} style={{ padding: "10px", cursor: "pointer", borderRadius: "10px", margin: "10px" }} onClick={e => props.selectChat(props.chat)}>
            <div className="symbol symbol-50px me-3">
                {
                    (!props.chat.image) &&
                    <div className='user-img text-primary bg-light-primary'>{abbreviate(props.chat.fullname)}</div>
                }

                {
                    (props.chat.image) &&
                    <img src={`${props.chat.image}`} alt="agent" />
                }
            </div>
            <div className="w-100">
                <div className="fs-7 text-dark fw-bold w-100">{props.chat.fullname}</div>
                <div className="fs-7 text-muted fw-bold last-message">{lastMessage}</div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        id: state.supervisor.id
    };
};
export default connect(mapStateToProps, { selectChat })(Chat);